import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const BoxTabs = lib.styled.div`
  display: flex;
  flex-direction: row!important;
  align-items: center;
  justify-content: space-between;

  .active {
    background: linear-gradient(50.28deg, #67C2E4 2.79%, #0C4BBC 73.37%);
    border: 0px;

    span {
      color: ${colors.white};
      letter-spacing: 0.05em;
      font-weight: 800;
    }
  }
`;

export const ItemTab = lib.styled.div`
  display: flex;
  flex-direction: row!important;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.lightGray06};
  width: 85px;
  height: 26px;
  border-radius: 30px;
  cursor: pointer;
  text-align: center;

  &:nth-child(1) {
    margin-right: 8px;
  }

  &:nth-child(2) {
    margin-right: 8px !important;
  }

  span:lang(de) {
    font-size: 11px;
  }
  
  span:lang(fr) {
    font-size: 11px;
  }
  
  span:lang(es) {
    font-size: 11px;
  }
  
  span:lang(pt) {
    font-size: 11px;
  }
  
  span:lang(nl) {
    font-size: 11px;
  }

  span {
    font-size: ${fonts.default}px;
    color: ${colors.darkGray05};
  }
`;

export const VoiceMessageTab = lib.styled.div`
  display: flex;
  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  width: 65px;
  height: 26px;
  cursor: pointer;
`;

export const VoiceButton = lib.styled.div`
  position: absolute;
  cursor: pointer;
  z-index: 999;

  span {
    font-size: 9px;
    color: ${colors.darkGray05};
  }
`;

export const Badge = lib.styled.span`
  width: 15px;
  padding: 2px;
  position: absolute;
  top: -6px;
  right: -9px;
  border-radius: 50%;
  background: #ea6056;
  font-weight: bold;
  color: white !important;
`;
